import { render, staticRenderFns } from "./indicatorPanel.vue?vue&type=template&id=124c7891&"
import script from "./indicatorPanel.vue?vue&type=script&lang=js&"
export * from "./indicatorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/nav/indicatorPanel.vue"
export default component.exports